module.exports = __webpack_public_path__ + "static/images/challenge.b4dca639cc67f63e7127c5d7ec7e9370.jpg";